//#region src/Auth/ColorUser/relatedTypes.ts
var PopulationRelationship = /* @__PURE__ */ function(PopulationRelationship) {
	PopulationRelationship["EMPLOYEE"] = "employee";
	PopulationRelationship["HEALTH_INSURANCE_BENEFICIARY"] = "health_insurance_beneficiary";
	PopulationRelationship["NON_HEALTH_INSURANCE_BENEFICIARY"] = "non_health_insurance_beneficiary";
	return PopulationRelationship;
}({});
//#endregion
export { PopulationRelationship as t };

//# sourceMappingURL=Auth-BJg8og-5.js.map